import React from 'react'

const LocaleContext = React.createContext({
    language: "sv",
    setLanguage: () => {}
  });

export default LocaleContext
